import type { TypeaheadTravelDates } from '@luxuryescapes/contract-search'
import type { OfferClickSearchParams } from 'tripPlanner/assistant/contexts/ChatMessageActionsContext'
import { convertDateRangesToMonthString, mapFlexibleNightsToDurationRange } from 'lib/search/flexibleDateUtils'

interface HotelSearchContext {
  searchDates?: TypeaheadTravelDates
  occupancy?: ReadonlyArray<{ adults: number; children?: number; childrenAge?: Array<number> }>
}

export function hotelSearchResultParams({ searchDates, occupancy }: HotelSearchContext): OfferClickSearchParams {
  const rooms = occupancy?.map(room => ({
    adults: room.adults,
    children: room.childrenAge?.length ?? room.children ?? 0,
    childrenAge: room.childrenAge,
    infants: 0,
  }))
  if (searchDates?.type === 'specific') {
    return { rooms, checkIn: searchDates.checkIn, checkOut: searchDates.checkOut }
  }
  if (searchDates?.type === 'flexible') {
    return {
      rooms,
      flexibleMonths: convertDateRangesToMonthString(searchDates.dateRanges),
      flexibleNights: mapFlexibleNightsToDurationRange(searchDates.numberOfNights),
    }
  }
  return { rooms }
}
